import React from 'react';
import { observer } from 'mobx-react';
import { translatableResourcePath } from '../../../utils/helpers';
import { FlexDiv } from '../../design-system/containers';

function EmailAttachment({
    isHoveringOnAttachment,
    attachment,
    t,
    handleAttachmentClick,
    handleAttachmentMouseEnter,
    handleAttachmentMouseLeave,
}) {
    const attachmentLabel = t(attachment.text);
    const previewSrc = translatableResourcePath(
        isHoveringOnAttachment ? attachment.iconHover : attachment.icon,
        t
    );

    return (
        <FlexDiv pt={24}>
            <div
                className="email-attachment-card"
                role="button"
                tabIndex={0}
                aria-label={attachmentLabel}
                onClick={handleAttachmentClick}
                onMouseEnter={handleAttachmentMouseEnter}
                onMouseLeave={handleAttachmentMouseLeave}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleAttachmentClick?.(event);
                    }
                }}
            >
                <div className="email-attachment-preview" aria-hidden="true">
                    <img src={previewSrc} alt="" />
                </div>
                <div className="email-attachment-filename">
                    <span className="email-attachment-pdf-icon" aria-hidden="true">
                        PDF
                    </span>
                    <span className="email-attachment-filename-text">
                        {attachmentLabel}
                    </span>
                </div>
            </div>
        </FlexDiv>
    );
}

export default observer(EmailAttachment);
